import { type FC, type ReactNode } from "react";

import { ReportPagesBar } from "@styled/report_pages_bar";

import { ReportFilePicker } from "./report_file_picker";

// Over the report's pages: his draft's file menu (`fileMenu`), else the
// report's files to pick from; the page in view (`page`, none while his Word
// draft covers them); then `actions`.
export const ReportFileBar: FC<{
  files: ReadonlyArray<{ id: string; name: string }>;
  fileId: string;
  name?: string;
  fileMenu: ReactNode;
  page: number | null;
  pageCount: number;
  actions: ReactNode;
  onSelect(id: string): void;
}> = ({
  files,
  fileId,
  name,
  fileMenu,
  page,
  pageCount,
  actions,
  onSelect,
}) => (
  <ReportPagesBar
    file={
      fileMenu || (
        <ReportFilePicker
          files={files}
          selectedId={fileId}
          selectedName={name ?? files.find((file) => file.id === fileId)?.name}
          onSelect={onSelect}
        />
      )
    }
    position={page !== null && `Page ${String(page)} of ${String(pageCount)}`}
    actions={actions}
  />
);
